// extracted by mini-css-extract-plugin
export default {"contentSidebarCanva":"ContentSidebar_contentSidebarCanva__pNzKm","contentSidebarCardsContainer":"ContentSidebar_contentSidebarCardsContainer__arVwW"};